// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__1L8zv","input":"TextInput_input__2FBKD"};